<template>
  <div class="">
    <div id="container"></div>
    <div class="container" v-if="contentDetail">
      <div class="tab-box" v-if="contentDetail.taskstauts == '已取消' || (contentDetail.taskstauts == '待执行' && !isStart) || contentDetail.taskstauts == '已结束'">
        <div class="title-box flex justify-between align-center">
          <div class="flex align-center">
             <image class="share-icon margin-bottom-xs" v-if="contentDetail.taskstauts == '待执行'" src="https://sass.gclme.com/api/file/Image/annex/20220425_8b85ce80009e45f8ab3f2ef172723de4.png" mode=""></image>
             <image class="share-icon margin-bottom-xs" v-if="contentDetail.taskstauts == '已结束'" src="https://sass.gclme.com/api/file/Image/annex/20220425_042ce2fc4fa74dc8b0d9f13d51acf0e3.png" mode=""></image>
             <image class="share-icon margin-bottom-xs" v-if="contentDetail.taskstauts == '已取消'" src="https://sass.gclme.com/api/file/Image/annex/20220425_e3e938a6205e452aa1b2cb983472085f.png" mode=""></image>
             <p class="color333">{{contentDetail.taskstauts}}</p>
          </div>
          <!-- <div class="el-icon-arrow-down"></div> -->
        </div>
        <div class="inner-box">
          <p class="color666">任务编号:{{contentDetail.taskcode}}</p>
          <div class="flex flex-derection alladress-box">
            <div class="flex align-center">
              <div class="adress-icon flex justify-center align-center">出</div>
              <div class="max-width560">
                {{contentDetail.planDeliveryAddress}}
              </div>
            </div>
            <div class="flex box-center">
              <div class="adress-icon adress-icon006DFF flex justify-center align-center">到</div>
              <div class="max-width560">
                {{contentDetail.planConsignAddress}}
              </div>
            </div>
            <div class="flex">
              <div class="adress-icon adress-icon3DBFFF flex justify-center align-center">收</div>
              <div class="max-width560">
                {{contentDetail.planCollectAddress}}
              </div>
            </div>
          </div>
          <p><span class="left-width">计划开始时间</span>{{contentDetail.planstartdatetime}}</p>
          <p v-if="contentDetail.taskstauts == '已结束'"><span class="left-width">出发时间</span>{{contentDetail.startdatetime}}</p>
          <p><span class="left-width">计划到货时间</span>{{contentDetail.plandatetime}}</p>
          <p v-if="contentDetail.taskstauts == '已结束'"><span class="left-width">到货时间</span>{{contentDetail.enddeliverytime}}</p>
          <p><span class="left-width">计划结束时间</span>{{contentDetail.planenddatetime}}</p>
          <p v-if="contentDetail.taskstauts == '已结束'"><span class="left-width">收车时间</span>{{contentDetail.collectdatetime}}</p>
          <p><span class="left-width">车牌号码</span>{{contentDetail.licenseplate}}</p>
          <p><span class="left-width">货品名称</span>{{contentDetail.cargoname}}</p>
          <p v-if="contentDetail.taskstauts == '待执行' && !isStart"><span class="left-width">收货人</span>{{contentDetail.consignee}}</p>
          <p v-if="contentDetail.taskstauts == '待执行' && !isStart"><span class="left-width">联系电话</span>{{contentDetail.phone}}</p>
          <p v-if="contentDetail.taskstauts == '已结束'"><span class="left-width">耗时</span>{{contentDetail.timeconsuming}}</p>
          <p v-if="contentDetail.taskstauts == '已结束'"><span class="left-width">超出计划时长</span>{{contentDetail.timelong}}</p>
          <p v-if="contentDetail.taskstauts == '已结束'"><span class="left-width">里程</span>{{contentDetail.surplusMileage}}</p>
        </div>
      </div>




      <div class="tab-box" v-if="contentDetail.taskstauts == '已结束' && contentDetail.gclTransportActuTaskAlarmEntityList && contentDetail.gclTransportActuTaskAlarmEntityList.length > 0" @click="giveAlarm()">
        <div class="inner-box">
          <p>告警信息总数:{{contentDetail.gclTransportActuTaskAlarmEntityList.length}}</p>
          <p v-for="(item,index) in contentDetail.gclTransportActuTaskAlarmEntityList" :key="index">告警信息{{index + 1}}:{{item.alarmreason}}</p>
        </div>
      </div>




      <div class="tab-box" v-if="contentDetail.taskstauts == '执行中' || isStart">
        <div class="title-box flex align-center">
          <div :class="index==TabCur?'text text-block':'text'" v-for="(item,index) in typeList"
          	:key="index" @click="filterArr(index)">{{item}}</div>
        </div>
        <div class="inner-box">
          <div class="inner-box-tab flex flex-derection">
            <div class="inner-box-go">
              <div class="">
                当前SOC:{{contentDetail.soc}}%
              </div>
              <div class="">
                <div class="inner-box-red" v-if="contentDetail.isShowLow">
                  电量低
                </div>
                <div class="inner-box-blue" v-if="contentDetail.isShow" @click="goChange()">
                  去换电
                </div>
              </div>
            </div>
            <p>距任务结束剩余里程:{{TabCur == 0 ? contentDetail.surplusMileage : (TabCur == 1 ? contentDetail.goMileage : contentDetail.backMileage)}}（km）</p>
            <p>距任务结束剩余时长:{{TabCur == 0 ? contentDetail.timelong : (TabCur == 1 ? contentDetail.gotime : contentDetail.backtime)}}h</p>
          </div>
        </div>
      </div>




      <div class="adress-box flex flex-derection" v-if="contentDetail.taskstauts == '执行中' || isStart">
        <div class="adress">
          <img class="adress-loc-icon" v-if="contentDetail.collectdatetime" src="../../../static/images/shouche.png" >
          <img class="adress-loc-icon" v-else src="../../../static/images/shouche-no.png" >
          <div v-if="contentDetail.collectdatetime"  class="flex flex-derection">
            <div class="time-box flex align-center">
              <span>已到达</span>{{contentDetail.collectdatetime}}
            </div>
            <p class="adress-get color333">[收车地址]{{contentDetail.planCollectAddress}}</p>
            <!-- 收货人:{{contentDetail.consignee}}  {{contentDetail.phone}} -->
          </div>
          <div v-else class="flex">
            <p class="adress-get">[收车地址]{{contentDetail.planCollectAddress}}</p>
          </div>
        </div>
        <div class="adress">
          <img class="adress-loc-icon" v-if="contentDetail.enddeliverytime" src="../../../static/images/shouhuo.png" >
          <img class="adress-loc-icon" v-else src="../../../static/images/shouhuo-no.png" >
          <div v-if="contentDetail.enddeliverytime" class="flex flex-derection">
            <div class="time-box flex align-center">
              <span>已到达</span>{{contentDetail.enddeliverytime}}
            </div>
            <p class="adress-get color333">[收货地址]{{contentDetail.planConsignAddress}}</p>
            <!-- 收货人:{{contentDetail.consignee}}  {{contentDetail.phone}} -->
          </div>
          <div v-else class="flex">
            <p class="adress-get">[收货地址]{{contentDetail.planConsignAddress}}</p>
          </div>
        </div>
        <div class="adress">
          <img class="adress-loc-icon" src="../../../static/images/go.png" >
          <div v-if="contentDetail.startdatetime" class="flex flex-derection">
            <div class="time-box flex align-center">
              <span>准备出发</span>{{contentDetail.startdatetime}}
            </div>
            <p class="adress-get color333">{{contentDetail.planDeliveryAddress}}</p>
          </div>
          <div v-else class="flex">
            <p class="adress-get">{{contentDetail.planDeliveryAddress}}</p>
          </div>
        </div>
      </div>
      <div class="adress-button" v-if="contentDetail.taskstauts == '执行中' || isStart">
        <div class="get-adress" v-if="lookText == '打卡'" @click="isRange()">{{lookText}}</div>
        <div class="get-adress get-adress-dis" v-else>{{lookText}}</div>
        <div class="get-adress" @click="gomap()">开始导航</div>
      </div>
      <div class="adress-button" v-if="contentDetail.taskstauts == '待执行' && !isStart">
        <div class="get-adress" @click="goStart()">开始执行任务</div>
      </div>
    </div>
  </div>
</template>
<script>
import AMapLoader from '@amap/amap-jsapi-loader';
export default {
  name: 'mapwebview',
  data() {
    return {
      map:null,
      typeList: [
      	'全程',
      	'去程',
      	'回程'
      ],
      TabCur: 0, // 选中下标
      id : null,
      lookText:'打卡',
      contentDetail:{},
      planDeliveryPosition:null,
      planConsignPosition:null,
      planCollectPosition:null,
      AMap :null,
      actionAdress : null ,  //给uniapp传入的参数
      // 围栏上下左右
      leftLo : null,
      rightLo : null,
      topLa : null,
      bottomLa : null,
      showClock : false, // 打卡按钮
      baseurl : null,  // 接口传过来的域名
      isStart : false,  // 是否开始
      dataPosition : undefined,  // 当前位置经纬度
    }
  },
  mounted() {
    this.id=this.$route.query.id;
    this.token=this.$route.query.token;
    this.baseurl=this.$route.query.baseurl;
    this.getContentDetail();
  },
  methods: {
    // 开始执行任务
    goStart(){
      var date = new Date(this.contentDetail.startdatetime),
          nowDate = new Date();
      var time = date.getTime(),
          nowDateTime = nowDate.getTime();
          alert(time - nowDateTime)
      if((time - nowDateTime) < 3600000 && (time - nowDateTime) > 0){
        this.isStart = true;
      }else{
        alert("开始执行任务仅限早于计划开始时间一小时内!")
      }

    },
    giveAlarm(){
      let dataPrm = {
        isAlarm : true,
        id : this.id
      }
      uni.postMessage({
          data: {
              action: dataPrm
          }
      });
    },
    goChange(){
      let dataPrm = {
        isChange : true,
        id : this.id
      }
      uni.postMessage({
          data: {
              action: dataPrm
          }
      });
    },
      getContentDetail(){
        this.$http({
          method : 'get',
          url : `${this.baseurl}/api/vehiclescheduling/GclTransportActuTask/app/getInfo/${this.id}`,
          headers:{
            'authorization': this.token
          }
        }).then(({ data }) => {
          this.contentDetail = data.data;
          //地球周长
          var perimeter = 2*Math.PI*6371000;
          var latitude_per_mi = 360 / perimeter;
          var longitude = this.contentDetail.railLongitude;
          var latitude = this.contentDetail.railLatitude;
          var radius = this.contentDetail.railRadius;
          //纬度latitude的地球周长：latitude
          var perimeter_latitude = perimeter*Math.cos(Math.PI * this.contentDetail.railLatitude / 180);
          //一米对应的经度（东西方向）1M实际度
          var longitude_per_mi = 360 / perimeter_latitude;
          this.leftLo =longitude-(radius*longitude_per_mi);
          this.rightLo =longitude+(radius*longitude_per_mi);
          this.topLa =latitude+(radius*latitude_per_mi);
          this.bottomLa =latitude-(radius*latitude_per_mi);
          this.initMap();
        })
      },
      initMap(){
        let _this = this;
          AMapLoader.load({
              key:"3c323c18d7f2d237ba10b4f06c5a1648",  // 申请好的Web端开发者Key，首次调用 load 时必填
              version:"2.0",      // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
              plugins:['AMap.Driving','AMap.Polyline','AMap.LabelMarker','AMap.PlaceSearch','AMap.Geolocation','AMap.CitySearch','AMap.Geocoder'],       // 需要使用的的插件列表，如比例尺'AMap.Scale'等
          }).then((AMap)=>{
              this.AMap = AMap;
              this.map = new AMap.Map("container",{  //设置地图容器id
                  viewMode:"3D",    //是否为3D地图模式
                  zoom:5,           //初始化地图级别
                  // center:[116.379028, 39.865042], //初始化地图中心点位置
              });
              if(this.contentDetail.deliverlongitude && this.contentDetail.deliverlatitude){
                this.planDeliveryPosition = [this.contentDetail.deliverlongitude, this.contentDetail.deliverlatitude];
              }else{
                alert("未检测到出发地址,请在后台重新配置!")
              }
              if(this.contentDetail.consignlongitude && this.contentDetail.consignlatitude){
                this.planConsignPosition = [this.contentDetail.consignlongitude, this.contentDetail.consignlatitude];
              }else{
                alert("未检测到收货地址,请在后台重新配置!")
              }
              if(this.contentDetail.collectlongitude && this.contentDetail.collectlatitude){
                this.planCollectPosition = [this.contentDetail.collectlongitude, this.contentDetail.collectlatitude];
              }else{
                alert("未检测到收车地址,请在后台重新配置!")
              }
              this.mapDriving();
              // this.mapLocation();
          }).catch(e=>{
              console.log('AMapErrol',e);
          })
      },
      // 绘制路线
      mapDriving(){
        var least_time,
            _this = this;
        least_time = new this.AMap.Driving({
          policy: AMap.DrivingPolicy.LEAST_TIME,//速度最快的策略
          map: this.map,
          autoFitView: true //自动调整地图视野使绘制的路线处于视口的可见范围
        })
        let opts = {
          waypoints : []
        }
        opts.waypoints[0] = _this.planConsignPosition;
        this.actionAdress = {
          planDeliveryPosition : _this.planDeliveryPosition,
          planDeliveryAddress : _this.contentDetail.planDeliveryAddress,
          planCollectPosition : _this.planCollectPosition,
          planCollectAddress : _this.contentDetail.planCollectAddress,
          opts : opts,
          planConsignAddress : _this.contentDetail.planConsignAddress
        };
        least_time.search(_this.planDeliveryPosition,_this.planCollectPosition,opts, (status, result) => {
          if (status === 'complete') {

          } else {
            console.log('Driving',result)
          }
        })
      },
      /*筛选订单的回调*/
      filterArr(index) {
      	this.TabCur = index
      },
      gomap(){
        let _this = this;
        uni.postMessage({
            data: {
                action: _this.actionAdress
            }
        });
      },
      // 定位
      mapLocation(){
        var location,
            _this = this;
        location = new this.AMap.Geolocation({
          // 是否使用高精度定位，默认：true
          enableHighAccuracy: true
        })
        location.getCurrentPosition(function(status,result){
          if(status=='complete'){
              _this.loopCall(result);
          }else{
              // onError(result)
          }
        });
      },
      isRange(){
        this.mapLocation();
      },
      loopCall(data){
        let dataPosition = data.position.toString().split(",");
        this.dataPosition = dataPosition
        if(!this.contentDetail.startdatetime){   // 出发地点
        console.log(this.leftLo + '-' + this.rightLo + '-' + this.topLa + '-' + this.bottomLa + '-' + data.position + '-' + dataPosition[0] + '-' + dataPosition[1])
          if((this.rightLo >= dataPosition[0] && dataPosition[0] >= this.leftLo) && (this.topLa >= dataPosition[1] && dataPosition[1] >= this.bottomLa) ){
            // 116.513  116.509   116.511  39.727  39.726
            // this.showClock = true;
            this.punchClock(1);
          }else{
            alert("未在出发点区域,暂不能打卡!")
          }
        }else if(!this.contentDetail.enddeliverytime){   // 收货地点
          if((this.rightLo >= dataPosition[0] && dataPosition[0] >= this.leftLo) && (this.topLa >= dataPosition[1] && dataPosition[1] >= this.bottomLa) ){
            // this.showClock = true;
            this.punchClock(2);

          }else{
            alert("未在收货点区域,暂不能打卡!")
          }
        }else if(!this.contentDetail.collectdatetime){   // 收车地址
          if((this.rightLo >= dataPosition[0] && dataPosition[0] >= this.leftLo) && (this.topLa >= dataPosition[1] && dataPosition[1] >= this.bottomLa) ){
            // this.showClock = true;
            this.punchClock(3);
          }else{
            alert("未在收车点区域,暂不能打卡!")
          }
        }
      },
      punchClock(type){
        // var citySearch = new this.AMap.CitySearch();
        var address,
            _this = this;

        var geocoder = new this.AMap.Geocoder();
        let loaction = this.dataPosition;
        geocoder.getAddress(loaction,function (status, result) {
          if (status === 'complete' && result.info === 'OK') {
            // 查询成功，result即为当前所在城市信息
            address = result.regeocode.formattedAddress;
            if(type == 1){   // 出发地点
              _this.$http({
                method : 'put',
                url : `${_this.baseurl}/api/vehiclescheduling/GclTransportActuTask/punchCard/${_this.id}/1/${address}/`,
                headers:{
                  'authorization': _this.token
                }
              }).then(({ data }) => {
                // _this.showClock = false;
                alert("打卡成功!")
                _this.lookText = "已打卡"
                setTimeout(()=>{
                  _this.getContentDetail();
                  _this.lookText = "打卡"
                },3000)
              })
              .catch(err=>alert(err));
            }else if(type == 2){   // 收货地点
              _this.$http({
                method : 'put',
                url : `${_this.baseurl}/api/vehiclescheduling/GclTransportActuTask/punchCard/${_this.id}/1/${address}/`,
                headers:{
                  'authorization': _this.token
                }
              }).then(({ data }) => {
                // _this.showClock = false;
                // _this.getContentDetail();
                 alert("打卡成功!")
                _this.lookText = "已打卡"
                setTimeout(()=>{
                  _this.getContentDetail();
                  _this.lookText = "打卡"
                },3000)
              }).catch((eroll)=>{
                alert(eroll)
              })
            }else if(type == 3){   // 收车地址
            alert(`${_this.baseurl}/api/vehiclescheduling/GclTransportActuTask/punchCard/${_this.id}/2/${address}/`)
              _this.$http({
                method : 'put',
                url : `${_this.baseurl}/api/vehiclescheduling/GclTransportActuTask/punchCard/${_this.id}/2/${address}/`,
                headers:{
                  'authorization': _this.token
                }
              }).then(({ data }) => {
                // _this.showClock = false;
                // _this.getContentDetail();
                 alert("打卡成功!")
                _this.lookText = "已打卡"
                setTimeout(()=>{
                  _this.getContentDetail();
                  _this.lookText = "打卡"
                },3000)
              }).catch((eroll)=>{
                alert(eroll)
              })
            }
          }
        })



        // _this.$http({
        //   method : 'post',
        //   url : `https://restapi.amap.com/v3/geocode/regeo?location=${this.dataPosition[0]},${this.dataPosition[1]}&key=3c323c18d7f2d237ba10b4f06c5a1648`,
        // }).then(({ data }) => {
        //   console.log(data)
        //   data = JSON.stringify(data)
        // })
        // citySearch.getLocalCity(function (status, result) {
        //   if (status === 'complete' && result.info === 'OK') {
        //     // 查询成功，result即为当前所在城市信息
        //     address = result.province + result.city;
        //     alert(type)
        //     if(type == 1){   // 出发地点
        //       _this.$http({
        //         method : 'put',
        //         url : `${_this.baseurl}/api/vehiclescheduling/GclTransportActuTask/punchCard/${_this.id}/1/${address}/`,
        //         headers:{
        //           'authorization': _this.token
        //         }
        //       }).then(({ data }) => {
        //         // _this.showClock = false;
        //         alert("打卡成功!")
        //         _this.lookText = "已打卡"
        //         setTimeout(()=>{
        //           _this.getContentDetail();
        //           _this.lookText = "打卡"
        //         },3000)
        //       })
        //       .catch(err=>alert(err));
        //     }else if(type == 2){   // 收货地点
        //       _this.$http({
        //         method : 'put',
        //         url : `${_this.baseurl}/api/vehiclescheduling/GclTransportActuTask/punchCard/${_this.id}/1/${address}/`,
        //         headers:{
        //           'authorization': _this.token
        //         }
        //       }).then(({ data }) => {
        //         // _this.showClock = false;
        //         // _this.getContentDetail();
        //          alert("打卡成功!")
        //         _this.lookText = "已打卡"
        //         setTimeout(()=>{
        //           _this.getContentDetail();
        //           _this.lookText = "打卡"
        //         },3000)
        //       }).catch((eroll)=>{
        //         alert(eroll)
        //       })
        //     }else if(type == 3){   // 收车地址
        //     alert(`${_this.baseurl}/api/vehiclescheduling/GclTransportActuTask/punchCard/${_this.id}/2/${address}/`)
        //       _this.$http({
        //         method : 'put',
        //         url : `${_this.baseurl}/api/vehiclescheduling/GclTransportActuTask/punchCard/${_this.id}/2/${address}/`,
        //         headers:{
        //           'authorization': _this.token
        //         }
        //       }).then(({ data }) => {
        //         // _this.showClock = false;
        //         // _this.getContentDetail();
        //          alert("打卡成功!")
        //         _this.lookText = "已打卡"
        //         setTimeout(()=>{
        //           _this.getContentDetail();
        //           _this.lookText = "打卡"
        //         },3000)
        //       }).catch((eroll)=>{
        //         alert(eroll)
        //       })
        //     }
        //   }
        // })
      },
  }
}
</script>
<style lang="stylus" scoped>
@import "./mapwebview.scss";
</style>



// WEBPACK FOOTER //
// mapwebview.vue?61641b13